import API from "./lib/api";
import { giftCardHistoryUrl } from "./lib/url";


export const getAllGiftCardHistoryApi = async (restaurant_id, query) => {
    try {
        const { data } = await API.get( 
            `restaurant/${restaurant_id}/gift-card-histories?${query}`
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}


export const addGiftCardHistoryApi = async (giftCardHistoryData) => {
    try {
        
        const response = await API.post( 
            `restaurant/gift-card-histories`,
            giftCardHistoryData
        );

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const singleGiftCardHistoryApi = async (id) => {
    try {
        
        const { data } = await API.get( 
            `${giftCardHistoryUrl}/${id}`
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}

export const editGiftCardHistoryApi = async (giftCardHistoryData, id) => {
    try {
        
        const { data } = await API.put( 
            `${giftCardHistoryUrl}/${id}`,
            {...giftCardHistoryData}
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}


export const deleteGiftCardHistoryApi = async (id) => {
    try {
        
        const response = await API.delete(`restaurant/gift-card-histories/${id}`);

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
            );
    }
}